var lang = $('html').attr('lang');

var last_scroll = 0;
var navbar_offset = 300;
var force_hidden_full = false;
var show_timeout = null;

var navbar_scroll = function(){
  var navbar = $('#navbar-top-scroll');
  var navbar_visible = navbar.length !== 0;
  var current_scroll = $(window).scrollTop();
  var limit = 120;

  if(current_scroll>navbar_offset){
    if(current_scroll<last_scroll && !force_hidden_full){

      navbar.addClass('show');
      clearTimeout(show_timeout);
      show_timeout = setTimeout(function(){
        navbar.removeClass('show');
      },3000);
    }
  }else{
    navbar.removeClass('show');
  }

  last_scroll = current_scroll;

};

function getScrollbarWidth() {
    var outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    var widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    var inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    var widthWithScroll = inner.offsetWidth;

    // remove divs
    outer.parentNode.removeChild(outer);

    return widthNoScroll - widthWithScroll;
}

$(function(){

  var scrollbar_width = getScrollbarWidth();

  $.easing.easeOutQuart = function (x, t, b, c, d) {
    return -c * ((t=t/d-1)*t*t*t - 1) + b;
  };

  var bLazy = new Blazy({
    breakpoints: [{
      width: 480,
      src: 'data-src-xs'
    },
    {
      width: 768,
      src: 'data-src-sm'
    }]
  });

  var addthisScript = document.createElement('script');
  addthisScript.setAttribute('src', 'http://s7.addthis.com/js/300/addthis_widget.js#domready=1');
  document.body.appendChild(addthisScript);

  $(window).bind('resize',function(){
    bLazy.revalidate();
  });

  $(window).bind('load',function() {
    $('.quotes-container .flexslider').flexslider({
      animation: 'slide',
      directionNav:false,
      prevText: '',
      nextText: ''
    });

    $('.header-box .flexslider').flexslider({
      controlNav:false,
      prevText: '',
      nextText: '',
      animationSpeed: 250,
      start:function(slider){
        bLazy.revalidate();
      },
      after:function(slider){
        bLazy.revalidate();
      }
    });
  });

  $('.header-box').on('click','.btn-scroll-container > a',function(e){
    e.preventDefault();
    $.scrollTo($(e.delegateTarget).height(), 800, {easing:'easeOutQuart'} );
  });

  $('.nav-registers').perfectScrollbar();

  $(window).bind('resize',function(){
    $('.nav-registers').perfectScrollbar('update');
  });

  $('.nav-registers .dropdown').on('show.bs.dropdown', function(e){
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown(500,'easeOutQuart',function(){
      $('.nav-registers').perfectScrollbar('update');
    });
  });

  $('.nav-registers .dropdown').on('hide.bs.dropdown', function(e){
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp(500,'easeOutQuart',function(){
      $('.nav-registers').perfectScrollbar('update');
    });
  });

  $('.modal .dropdown').on('show.bs.dropdown', function(e){
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown(500,'easeOutQuart');
  });

  $('.modal .dropdown').on('hide.bs.dropdown', function(e){
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp(500,'easeOutQuart');
  });

  var navbar_top_timeout;

  $(document).on('show.bs.dropdown','.navbar-top .dropdown', function(e){
    if(!$(this).closest('.navbar-top').hasClass('navbar-top-scroll'))
    {
      clearTimeout(navbar_top_timeout);
      $('.navbar-top').addClass('navbar-open');
    }

    $(this).find('.dropdown-menu').first().stop(true, true).slideDown(500,'easeOutQuart');
  });

  $(document).on('hide.bs.dropdown','.navbar-top .dropdown', function(e){
    if(!$(this).closest('.navbar-top').hasClass('navbar-top-scroll'))
    {
      navbar_top_timeout = setTimeout(function(){
        $('.navbar-top').removeClass('navbar-open');
      },500);
    }

    $(this).find('.dropdown-menu').first().stop(true, true).slideUp(500,'easeOutQuart');
  });

  $(window).bind('load',function(){

    navbar_main = $('#navbar-main');
    navbar = navbar_main.clone();
    submenu = $('#sub-menu-main');

    navbar.attr('id','navbar-top-scroll')
    .addClass('navbar-top-scroll')
    .prependTo('.navbars-container');

    navbar.hover(
      function(){
        clearTimeout(show_timeout);
      },
      function(){
        show_timeout = setTimeout(function(){
          navbar.removeClass('show');
        },3000);
      }
    );

    navbar.css('width',navbar_main.width()+'px');

    $(window).bind('resize',function(){
      navbar.css('width',navbar_main.width()+'px');
    });

  });

  $(window).bind('scroll',function(){
    $('.navbar-top .dropdown.open .dropdown-menu').dropdown('toggle');
  });

  $(window).bind('scroll',navbar_scroll);

  $(window).bind('resize',function(){
    if($('body').hasClass('modal-open')){
      $('.modal-blue.in').modal('toggle');
    }
  });

  /*$('.section-scroll').perfectScrollbar({suppressScrollX:true});

  $('.section-scroll').unbind('mousewheel');
  $('.section-scroll').unbind('wheel');

  $(window).bind('resize',function(){
    $('.section-scroll').perfectScrollbar('update');
  });*/

  $('.section-block').on('click','.btn-section-open',function(e){
    e.preventDefault();
    var menu = $(e.delegateTarget).children('.menu');

    menu.fadeIn(300);
  });

  $('.section-block').on('click','.btn-section-close',function(e){
    e.preventDefault();
    var menu = $(e.delegateTarget).children('.menu');

    menu.fadeOut(300);
  });

  $('.section-block').on('click','.menu a[data-toggle="tab"]', function (e) {
    e.preventDefault();
    var menu = $(e.delegateTarget).children('.menu');

    menu.fadeOut(300);
  });

  $('.discount-detail-image').on('click',function(e){
    e.preventDefault();

    var hash = $(this).attr('href');

    $.scrollTo(hash, 800, {easing:'easeOutQuart',offset:-50} );
  });

  $('.spotlight-block').on('click','.navigator-container a',function(e){
    e.preventDefault();

    var spotlight_block = $(e.delegateTarget);
    var spotlight_tab = spotlight_block.find('.spotlight-tab');
    var new_spotlight_tab = spotlight_tab.clone().hide().insertAfter(spotlight_tab);
    var page=spotlight_block.attr('data-prev');
    var table = new_spotlight_tab.find('.table');

    table.empty();

    if($(this).data('direction')=='next')
    {
        page=spotlight_block.attr('data-next');
    }

    spotlight_tab.fadeOut('fast',function(){
      $(this).remove();
      $.getJSON(spotlight_block.data('route'),{'page':page}, function( data ) {
        new_spotlight_tab.find('.title').text(data.modality.name);
        spotlight_block.attr('data-prev',data.prev_page);
        spotlight_block.attr('data-next',data.next_page);

        if(data.modality.calendar_events)
        {
        $.each(data.modality.calendar_events,function(key,value){

          var row = $('<tr></tr>').appendTo(table);

          $('<td></td>').appendTo(row).append(value.label);
          $('<td></td>').appendTo(row).append(value.description);

          var date_cell = '<td></td>';

          if(value.calendar_event_time){
            $('<td></td>').appendTo(row).append(value.calendar_event_time.substring(0, 5));

          }else{
            date_cell = '<td colspan="2"></td>';
          }


          $(date_cell).appendTo(row).append(value.calendar_event_date.substring(8, 10) + '.' + value.calendar_event_date.substring(5, 7) + '.' + value.calendar_event_date.substring(0, 4));

          var news_td = $('<td class="more-cell"></td>').appendTo(row);

          if(value.news)
          {
            news_td.append('<a href="'+spotlight_block.data('route-news')+'/'+value.news.slug+'" class="icon-more"></a>');
          }
        });
        }
        if(data.modality.results)
        {
        $.each(data.modality.results,function(key,value){

          var row = $('<tr></tr>').appendTo(table);

          $('<td></td>').appendTo(row).append(value.label);
          $('<td></td>').appendTo(row).append(value.description);

          $('<td></td>').appendTo(row).append(value.result_date.substring(8, 10)+'.'+value.result_date.substring(5, 7)+'.' + value.result_date.substring(0, 4));

          var news_td = $('<td class="more-cell"></td>').appendTo(row);

          if(value.news)
          {
            news_td.append('<a href="'+spotlight_block.data('route-news')+'/'+value.news.slug+'" class="icon-more"></a>');
          }
        });
        }

        new_spotlight_tab.fadeIn('fast');
      });
    });
  });

  $(document).on('submit','.ajax-request',function(e){
    var form = $(this);
    var modal = $('#modal-messages');
    var modal_content = modal.find('.modal-body');
    var button = form.find('[type=submit][data-loading-text]');

    button.button('loading');

    modal.find('.modal-title').text(form.data('title'));

    modal_content.empty();

    e.preventDefault();

    $.ajax({
      url: form.attr('action'),
      type: form.attr('method'),
      data: form.serialize(),
      dataType: "json"
    }).done(function(data) {
      if (data.success) {
        form[0].reset();
        form.find('.form-feedback').removeClass('icon-close2 icon-check2');
        form.find('.form-group-clickable .form-control').slideUp(300);
        modal_content.append(data.message);
      }else{
        var messages = '';

        $.each(data.messages, function(i, item) {
          messages+=item+'<br/>';
        });

        modal_content.append(messages);
      }

      modal.modal('show');

      button.button('reset');

    });
  });

  $('.form-group-clickable .form-control').not('select').hide();

  $('.form-group-clickable').on('click',function(){
    var form_group = $(this);
    var input = form_group.children('.form-control').not('select');

    input.slideDown(300).focus();
  });

  $(document).on('focusout','[data-validate]',function(){
    var input = $(this);

    var form = input.closest('form');

    $.getJSON(input.data('validate')+'?'+form.serialize(), function(data) {
      if(data.success){
        input.next('.form-feedback').removeClass('icon-close2').addClass('icon-check2');
      }else{
        input.next('.form-feedback').removeClass('icon-check2').addClass('icon-close2');
      }
    });
  });

  $('[name=born_date_grown_up]').inputmask("dd/mm/yyyy", {
    placeholder: "DD/MM/AAAA"});

  $('#born_date').inputmask("dd/mm/yyyy", {
    placeholder: "DD/MM/AAAA",
    oncomplete:function(){
      var date = $(this).val();
      var birthday = new Date(date.substring(6,10),date.substring(3,5) - 1, date.substring(0,2));

      var ageDifMs = Date.now() - birthday.getTime();
      var ageDate = new Date(ageDifMs);

      if(ageDate.getUTCFullYear() - 1970 < 18){
        $('#encarregado-de-educacao').slideDown(300);
        $('[name=grown_up]').val(1);
      }else{
        $('#encarregado-de-educacao').slideUp(300);
        $('[name=grown_up]').val(0);
      }
    }
  });

  $('select.form-control').chosen({width:'auto'})
    .on('chosen:showing_dropdown',function(){
      $(this).next('.chosen-container').children('.chosen-drop').slideDown(300);
    })
    .on('chosen:hiding_dropdown',function(){
      $(this).next('.chosen-container').children('.chosen-drop').slideUp(300);
    })
  ;



  /*$('.modal').on('show.bs.modal', function (e) {
    $('.nav-header-fixed').css('right',scrollbar_width+'px');
  });

  $('.modal').on('hidden.bs.modal', function (e) {
    $('.nav-header-fixed').css('right','0');
  });*/

  $('input, textarea').placeholder();

  $('.header-box .flexslider').on('mousemove', function (e) {
    var $this = $(this),
        width = $this.width();

    if (e.pageX < width / 2) {
      $this.addClass('flexslider--hover-left')
          .removeClass('flexslider--hover-right');
    } else {
      $this.addClass('flexslider--hover-right')
          .removeClass('flexslider--hover-left');
    }
  }).on('mouseout', function () {
    var $this = $(this);

    $this.removeClass('flexslider--hover-right')
        .removeClass('flexslider--hover-left');
  });

  var $discountFooter = $('.footer-discounts');

  $(window).on('scroll resize', function() {
    if($(window).scrollTop() > $discountFooter.height()) {
      console.log(!localStorage.getItem('discountHide') && !$discountFooter.is(':visible'));

      if(!localStorage.getItem('discountHide') && !$discountFooter.is(':visible')) {
        $discountFooter.fadeIn();
      }
    } else {
      $discountFooter.fadeOut(200);
    }
  });

  $('.footer-discounts__close').on('click', function(e) {
    e.preventDefault();

    $discountFooter.fadeOut(400, function() {
      localStorage.setItem('discountHide', true);
    });
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/main.js